import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

// Utils
import { NavHeight, PageGutter, Colors } from "../utils/constants";

// MUI
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

// Components
import Typography from "./Typography";
import Button from "./Button";
import BannerTagFlyer from "./CodeNationBannerTag";

// Icons
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";

const Container = styled(Stack)`
    position: relative;

    ${(props) =>
        props.lighttheme === "true" &&
        `
        h1, h2 {
            color: white;
        }

        p {
            color: white;
        }

        button {
            color: white;
            border-color: white;
        }
    `}

    ${(props) =>
        props.image &&
        `
        background-image: url(${props.image});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    `}

    min-height: calc(100vh - (${NavHeight}));
    padding: ${PageGutter};
`;

const HeroBanner = ({
    lighttheme = false,
    smallTitle = "",
    title = "",
    subtitle = "",
    titleWidth = "900px",
    subtitleWidth = "800px",
    cta = "",
    image,
    showBack = false,
    backBtnRoute = null,
    onClick,
}) => {
    const navigate = useNavigate();

    return (
        <Container
            justifyContent="center"
            lighttheme={lighttheme ? "true" : "false"}
            image={image}
        >
            {showBack ? (
                <Button
                    startIcon={<ChevronLeftRoundedIcon />}
                    variant="outlined"
                    onClick={
                        backBtnRoute
                            ? () => navigate(backBtnRoute)
                            : () => navigate(-1)
                    }
                    sx={{
                        marginBottom: 3,
                        width: "100px",
                        color: lighttheme ? "white" : Colors.accent,
                        borderColor: lighttheme ? "white" : Colors.accent,
                        "&:hover": {
                            color: lighttheme ? "white" : Colors.accent,
                        },
                        zIndex: 1,
                    }}
                >
                    Back
                </Button>
            ) : (
                <BannerTagFlyer href={"code-the-nation"} />
            )}
            {lighttheme && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        zIndex: 0,
                        background: {
                            xs: "rgba(0,0,0,0.6)",
                            lg: "linear-gradient(90deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 80%);",
                        },
                    }}
                />
            )}
            {smallTitle && (
                <Typography
                    variant="h2"
                    mb
                    sx={{ maxWidth: titleWidth, zIndex: 1 }}
                >
                    {smallTitle}
                </Typography>
            )}
            <Typography
                variant="h1"
                mb
                sx={{ maxWidth: titleWidth, zIndex: 1 }}
            >
                {title}
            </Typography>
            <Typography
                variant="subheader"
                mb
                sx={{ maxWidth: subtitleWidth, zIndex: 1 }}
                dangerouslySetInnerHTML={{ __html: subtitle }}
            />
            {cta && (
                <Button
                    variant="outlined"
                    sx={{ width: "fit-content", marginTop: "20px", zIndex: 1 }}
                    onClick={onClick}
                >
                    {cta}
                </Button>
            )}
            <IconButton
                color="primary"
                aria-label="scroll down"
                onClick={() => window.scrollBy(0, window.innerHeight)}
                sx={{ width: "fit-content", mt: 2 }}
            >
                <ArrowDownwardRoundedIcon />
            </IconButton>
        </Container>
    );
};

export default HeroBanner;
